/*
	http://kenwheeler.github.io/slick/
*/
function fnSlickSlider( i, oSection ) {

	/**
	* Marquee fade  (section.marquee-fade)
	*/
	$( 'section.marquee-fade .slick-slider' ).not('.slick-initialized').slick({
		touchThreshold:   	 		20,
		autoplay:   	      		false,
		centerMode:   	    		true,
		centerPadding:   	 		'0px',
		dots:   	          		true,
		arrows:   	        		false,
		infinite:   	        	false,
		slidesToScroll:   			1,
		slidesToShow: 				1,
		speed:   	         		300,
		adaptiveHeight:   			true,
		mobileFirst:   	   			true,
		focusOnSelect:   	 		true,
		responsive: [
            {
                breakpoint: 		768,
                settings : {
					variableWidth: 	true,
                }
            },
            {
                breakpoint: 		0,
                settings : {
					variableWidth: 	false,
                }
            }
        ]
	 });

 	/**
 	* Marquee testimonials (section.marquee-testimonials)
 	*/
 	$( 'section.marquee-testimonials .slick-slider' ).not('.slick-initialized').slick({
		touchThreshold:   	 		20,
		autoplay:   	      		false,
		centerMode:   	    		true,
		centerPadding:   	 		'0px',
		dots:   	          		true,
		arrows:   	        		false,
		infinite:   	        	false,
		slidesToScroll:   			1,
		slidesToShow: 				1,
		speed:   	         		300,
		adaptiveHeight:   			true,
		mobileFirst:   	   			true,
		focusOnSelect:   	 		true
 	 });
	  const breakpoint = {
		// Small screen / phone
		sm: 576,
		// Medium screen / tablet
		md: 768,
		// Large screen / desktop
		lg: 992,
		// Extra large screen / wide desktop
		xl: 1200
	  };
	 // TESTIMONIALS
		$('section.hp-testimonials .testimonials-holder').not('.slick-initialized').slick({
			dots: false,
			prevArrow: true,
			nextArrow: true,
			slidesToShow: 3,
			slidesToScroll: 1,
			speed: 500,
			cssEase: 'linear',
			centerMode: true,
			arrows: true,
			prevArrow: '<i class="fa-solid fa-arrow-left"></i>',
			nextArrow: '<i class="fa-solid fa-arrow-right"></i>',
			autoplay: true,
			autoplaySpeed: 3000,
			variableWidth: false,
			responsive: [
				{
					breakpoint: breakpoint.lg,
					settings : {
						slidesToShow: 2,

					}
				},
				{
					breakpoint: breakpoint.md,
					settings : {
						slidesToShow: 1,
						arrows: false
					}
				}
			]
		});
	// PRODUCT CAROUSEL
		$('.main-carousel').not('.slick-initialized').slick({
			dots: false,
			prevArrow: false,
			nextArrow: false,
			infinite: true,
			speed: 500,
			fade: true,
			cssEase: 'linear'
		  });
			$('.phone-carousel').not('.slick-initialized').slick({
			dots: false,
			prevArrow: false,
			nextArrow: false,
			infinite: true,
			speed: 500,
			fade: true,
			cssEase: 'linear'
		  });
		  $('.clinic-carousel').not('.slick-initialized').slick({
			dots: false,
			prevArrow: false,
			nextArrow: false,
			infinite: true,
			speed: 500,
			fade: true,
			cssEase: 'linear'
		  });

		  $('.text[data-slide]').hover(function(e) {
			e.preventDefault();   
			var slideno = $(this).data('slide');
			$('.phone-carousel').slick('slickGoTo', slideno - 1);
	
			var index = $(this).attr("data-slide");
			var height = $('.text[data-slide =  '+index+']').height();
			var textTop = $('.text[data-slide =  '+index+']').position().top;
			$('.highlight').css({top: textTop + 'px', height: height}).animate({top: textTop + 'px', height: height + 'px'}, 100);
		 });
		 $('.text2[data-slide]').hover(function(e) {
			e.preventDefault();
			var slideno = $(this).data('slide');
			$('.clinic-carousel').slick('slickGoTo', slideno - 1);
			
			var index = $(this).attr("data-slide");
			var height = $('.text2[data-slide =  '+index+']').height();
			var textTop = $('.text2[data-slide =  '+index+']').position().top;
			$('.highlight').css({top: textTop + 'px', height: height}).animate({top: textTop + 'px', height: height + 'px'}, 100);
		 });
		 $('.product-carousel-buttons .button[data-slide]').hover(function(e) {
			e.preventDefault();
			var slideno = $(this).data('slide');
			$('.main-carousel').slick('slickGoTo', slideno - 1);
		
		 });
		 $('.product-carousel-buttons .button[data-slide]').hover(function(e) {
		  $(this).addClass('active');
		  $(this).closest('div').find('.button').not(this).removeClass('active');
		 });
		 

		// SERVICES
		$('.logos-holder').not('.slick-initialized').slick({
			dots: false,
			prevArrow: false,
			nextArrow: false,
			infinite: false,
			speed: 500,
			cssEase: 'linear',
			slidesToShow: 7,
			slidesToScroll: 1,
			responsive: [
				{
				  breakpoint: 1024,
				  settings: {
					slidesToShow: 5,
					slidesToScroll: 5,
					infinite: true,
					autoplay: true
				  }
				},
				{
					breakpoint: 960,
					settings: {
					  slidesToShow: 4,
					  slidesToScroll: 4,
					  infinite: true,
					  autoplay: true
					}
				  },
				{
				  breakpoint: 700,
				  settings: {
					slidesToShow: 2,
					slidesToScroll: 2,
					infinite: true,
					autoplay: true
				  }
				}
			  ]
		  });

}
$(window).resize(function(){
	$('section.hp-testimonials .testimonials-holder')[0].slick.refresh();
  });
  